import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withPage } from "../../Page";
import ActionCreator from "../../ActionCreator";
import * as Widget from "../../Components/Widget2";
import FindIntroduction from "../../Components/FindIntroduction";
import Image from "../../Components/Image";
import * as ReactScroll from "react-scroll";
import ChattyButton from "../../../chatty/Components/ChattyButton";

let RoastData = [
  { name: "light", display: "淺焙", img: "icon04.png" },
  { name: "medium", display: "中焙", img: "icon05.png" },
  { name: "heavy", display: "深焙", img: "icon06.png" }
];

const UiState = {
  light: "light",
  medium: "medium",
  heavy: "heavy"
};

class FindRoastPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uiState: ""
    };
  }
  render() {
    let { navActions } = this.props;
    let { uiState, openCattyScreen } = this.state;
    return (
      <Wrapper
        css={`
          margin-top: 112px;
          @media screen and (max-width: 1000px) {
            margin-top: 40px;
          }
          @media screen and (max-width: 550px) {
            margin-top: 20px;
          }
        `}
      >
        <div className="left">
          <div className="title">- 找焙度 -</div>
          <div className="subtitle">請選擇你喜愛的焙度</div>
          <Widget.Col
            justify="center"
            align="flex-start"
            css={`
              position: relative;
              max-width: 100%;
              @media screen and (max-width: 1000px) {
                justify-content: center;
              }
            `}
          >
            {RoastData.map((d, i) => (
              <RoastItem
                key={i}
                selected={uiState === d.name}
                onClick={() => {
                  this.setState({ uiState: d.name }, () => {
                    // only need scrolling when column layout (ex. mobile device)
                    if (window.innerWidth <= 1000) {
                      ReactScroll.animateScroll.scrollMore(400);
                    }
                  });
                }}
              >
                <div className="dot" />
                <img src={`/images/pages/products/${d.img}`} />
                <div>{d.display}</div>
              </RoastItem>
            ))}
          </Widget.Col>
        </div>
        <div className="right">
          {uiState === "" && (
            <div className="cover-img">
              <Image background src="./images/pages/find/2.png" />
            </div>
          )}
          {uiState === UiState.light && (
            <FindIntroduction find={UiState.light} />
          )}
          {uiState === UiState.medium && (
            <FindIntroduction find={UiState.medium} />
          )}
          {uiState === UiState.heavy && (
            <FindIntroduction find={UiState.heavy} />
          )}
        </div>
        <ChattyButton />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
  min-height: 900px;

  & > .left {
    padding: 20px;
    max-width: 500px;
    width: 100%;

    & > .title {
      margin-bottom: 20px;
      letter-spacing: 3.9px;
      font-size: 26px;
    }

    & > .subtitle {
      margin-bottom: 50px;
      font-size: 14px;
      color: #636363;
    }
  }

  & > .right {
    padding: 20px;
    flex: 1;

    & > .cover-img {
      width: 100%;
      height: 450px;
      background-color: lightgray;
    }
  }

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    & > .left {
      padding: 10px;
      text-align: center;
      align-self: center;
    }

    & > .right {
      margin-bottom: 100px;
      padding: 73px;
    }
  }

  @media screen and (max-width: 600px) {
    & > .right {
      padding: 40px;
    }
  }

  @media screen and (max-width: 550px) {
    & > .right {
      padding: 20px;

      & > .cover-img {
        max-width: 400px;
        height: 273px;
      }
    }
  }

  @media screen and (max-width: 375px) {
    & > .left {
      max-width: 100%;
    }
    & > .right {
      padding: 10px;
    }
  }

  ${props => props.css};
`;

const RoastItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-bottom: 20px;
  cursor: pointer;
  min-width: 200px;

  & > .dot {
    position: relative;
    z-index: 3;
    margin-right: 20px;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    background: ${props => (props.selected ? "#755B41" : "transparent")};
  }

  & > img {
    margin-right: 10px;
    width: 70px;
    height: 70px;
  }

  & > div {
    font-size: 16px;
  }

  @media screen and (max-width: 1000px) {
    margin: 0 auto;
  }

  ${props => props.css}
`;

export default withPage(
  connect(
    null,
    ActionCreator
  )(FindRoastPage)
);
